<template>
  <!-- 联系我们 -->
  <div class="Contact" style="align-self: center">
    <!-- 黑头 -->
    <div class="header flex-all-center">
      <p>{{ $t("contact.text1_1") }}</p>
    </div>

    <div class="main">
      <div class="maincontent">
        <div class="textlayout">
          <div class="text">
            <!-- 左边表格 -->
            <p class="flex-all-center title-1">
              {{ $t("contact.phoneNumber") }}
            </p>
            <!-- 迪拜公司 -->
            <p class="title-1">{{ $t("contact.DUBAIOffice") }}</p>
            <p>
              <strong>{{ $t("contact.adress") }}</strong
              >{{ $t("contact.DUBAIAdress") }}
            </p>
            <p>
              <strong>{{ $t("contact.email") }}</strong
              >{{ $t("contact.DUBAIEmail") }}
            </p>
            <p>
              <strong>{{ $t("contact.phone") }}</strong
              >{{ $t("contact.DUBAIPhone") }}
            </p>
            <!-- 中国公司 -->
            <p class="title-1">{{ $t("contact.CHINAOffice") }}</p>
            <p>
              <strong>{{ $t("contact.adress") }}</strong
              >{{ $t("contact.CHINAAdress") }}
            </p>
            <p>
              <strong>{{ $t("contact.email") }}</strong
              >{{ $t("contact.CHINAEmail") }}
            </p>
            <p>
              <strong>{{ $t("contact.CHINAContactPerson") }}</strong
              >{{ $t("contact.Fred") }}
            </p>
            <p>
              <strong>{{ $t("contact.phoneNumber2") }}</strong
              >{{ $t("contact.CHINAContactNumber") }}
            </p>
            <p>
              <strong>{{ $t("contact.fixedPhone") }}</strong
              >{{ $t("contact.CHINALandline") }}
            </p>
            <!-- 马来西亚公司 -->
            <p class="title-1">{{ $t("contact.MALAYSIAOffice") }}</p>
            <p>
              <strong>{{ $t("contact.adress") }}</strong
              >{{ $t("contact.MALAYSIAAdress") }}
            </p>
            <p>
              <strong>{{ $t("contact.email") }}</strong
              >{{ $t("contact.MALAYSIAEmail") }}
            </p>
            <p>
              <strong>{{ $t("contact.phone") }}</strong
              >{{ $t("contact.MALAYSIAPhone") }}
            </p>
          </div>
          <!-- 右边表单 -->
          <div class="text2">
            <p class="flex-all-center title-2">{{ $t("contact.text1") }}</p>
            <p class="mb-24 flex-all-center">{{ $t("contact.text2") }}</p>
            <div class="contact-form-border">
              <!-- 表单主体 -->
              <p class="required">{{ $t("contact.name") }}</p>
              <input type="text1" :placeholder="$t('contact.firstName_none')" v-model="formData.firstname" />
              <input type="text2" :placeholder="$t('contact.lastName_none')" v-model="formData.lastname" />
              <p class="required">{{ $t("contact.email") }}</p>
              <input type="email" :placeholder="$t('contact.email_none')" v-model="formData.email" />
              <p>{{ $t("contact.advice") }}</p>
              <textarea
                type="emailinput"
                :placeholder="$t('contact.advice_none')"
                 v-model="formData.message"
              ></textarea>
              <button type="submit"  @click="submitForm" >{{ $t("contact.submit") }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer"></div>
  </div>
</template>

<script>
export default {
  name: "Contact",
  components: {},
  data() {
    return {
      formData: {
        firstname: '',
        lastname: '',
        email: '',
        message: ''
      }
      };
  },
  computed: {},
  created() {},
  methods: {
    async submitForm() {
    try {
      // 构造你想要的JSON格式
      const payload = {
        client_source: "blacklocustcap",
        customer_name: this.formData.firstname + this.formData.lastname,
        customer_email: this.formData.email,
        customer_message: this.formData.message,
        customer_phone: "",
        customer_company: "",

      };
      // 跨域请求，允许保存cookie
      this.$axios.defaults.withCredentials = true
      const response = await this.$axios.post('/api/submit', payload, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
    // 清空表单
    this.resetFormData();

    if (response.status === 200) { // 检查HTTP状态码是否为200
    // console.log('Response data:', response.data);

    // 也可以添加一个用户通知，例如：
    this.$message({
      message: '发送成功',
      type: 'success'
      });
      }

    // console.log('Response data:', response.data);
      // Reset formData or notify the user on success
    } 
    catch (error) {
      console.error('There was an error submitting the form:', error);
    }
  },

    resetFormData() {
    // 将表单数据重置为空字符串的函数
    this.formData.name = '';
    this.formData.email = '';
    this.formData.message = '';
  }

  },
};
</script>

<style lang="scss" scoped>
.Contact {
  color: #000;
  width: 100%;
}

.header {
  height: 400px;
  background: #000;
  font-family: "OPPO-L";
  font-size: 42px;
  color: #fff;
  p {
    text-align: center;
  }
}

.main {
  display: flex;
  justify-content: center;
}
.textlayout {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-top: 80px;
}

.maincontent {
  max-width: 1200px;
  color: #606266;
  font-family: "OPPO-R";
  font-size: 17px;
  line-height: 27px;
  width: 100%;
  p {
    margin-top: 17px;
  }
  .text {
    width: 531px;
    margin-right: 67px;
  }
  .text2 {
    font-family: "OPPO-B";
    width: 602px;
    height: 537px;
  }
}

.title-1 {
  font-family: "OPPO-B";
  font-size: 22px;
  color: #b49c4c;
}

.title-2 {
  font-family: "OPPO-B";
  font-size: 22px;
  color: #000;
}

.contact-form-border {
  border: 2px solid #000;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
  max-width: 602px;
  height: 437px;
  padding: 20px;
  border-radius: 8px;
}

input[type="text1"] {
  width: 30%;
  padding: 10px;
  margin-top: 5px;
  border-radius: 10px;
  border: 1px solid #ccc;
}

input[type="text2"] {
  width: 30%;
  padding: 10px;
  margin-top: 5px;
  margin-left: 10px;
  border-radius: 10px;
  border: 1px solid #ccc;
}

input[type="email"] {
  width: 100%;
  padding: 10px;
  margin-top: 5px;
  border-radius: 10px;
  border: 1px solid #ccc;
}

textarea {
  width: 100%;
  height: 20%;
  padding: 10px;
  margin-top: 5px;
  border-radius: 10px;
  border: 1px solid #ccc;
}

button {
  width: 127px;
  margin-top: 10px;
  padding: 10px;
  background-color: #000;
  color: #fff;
  border: none;
  border-radius: 10px;
  cursor: pointer;
}

// 这里做了一个取巧的办法,姓名和邮箱后面的*是单独设置的,在required这个标签里
.required::after {
  content: "*";
  color: red;
}

.footer {
  margin-top: 120px;
}

@media (max-width: 768px) {
  .textlayout {
    display: flex;
    flex-direction: column;
  }

  .maincontent {
    width: 90%;
    color: #606266;
    font-family: "OPPO-R";
    font-size: 17px;
    line-height: 27px;
    margin-top: 17px;
    p {
      margin-top: 17px;
    }
    .text {
      width: 100%;
    }
    .text2 {
      width: 100%;
    }
    .footer {
      margin-top: 40px;
    }
  }
}
</style>
